import React from 'react';
import {SVG__Ruble} from "../../SVG/SVG";

class BasketItem extends React.Component {

    constructor(props) {
        super(props);
        this._onChange = this._onChange.bind(this);
        this._onInc = this._onInc.bind(this);
        this._onDec = this._onDec.bind(this);
    }

    _onChange(event) {
        this.props._onChangeBasketHandle(+event.target.value);
    }

    _onInc(event) {
        event.preventDefault();
        let value = +this.props.item.quantity + 1 || 1;
        this.props._onChangeBasketHandle(value);
    }

    _onDec(event) {
        event.preventDefault();
        let value = +this.props.item.quantity - 1 || 1;
        this.props._onChangeBasketHandle(value);
    }

    render() {
        const {item} = this.props;
        // const price = (item.price > 0) ? item.price : 'Цена по запросу';
        //
        // let titalPrice = item.price * price;
        // titalPrice = titalPrice > 0 ? titalPrice : 'Цена по запросу';
        const itemPriceHTML = (item.price > 0)? <span>{(item.price.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '))} <SVG__Ruble/></span>:this.props.zeroPrice;
        const totalPrice = item.price * item.quantity;
        const totalPriceHTML = (totalPrice > 0)? <span>{(totalPrice.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '))} <SVG__Ruble/></span>:this.props.zeroPrice;

        return (
            <div className="basket-items__item">
                <div className="image">
                    <img src={process.env.REACT_APP_SERVER + item.image} alt={item.name}/>
                </div>

                <div className="title">
                    <a href={item.link}>{item.name}</a>
                </div>

                <div className="price">{itemPriceHTML}</div>

                <div className="quantity">
                    <input type="text" value={item.quantity} onChange={this._onChange}/>
                    <button className={"quantity-btn"} onClick={this._onDec}>-</button>
                    <button className={"quantity-btn"}  onClick={this._onInc}>+</button>
                </div>

                <div className="total_price">{totalPriceHTML}</div>

                <div className="remove" onClick={() => this.props._onRemoveBasketItem(item.id)}>
                    <svg className="svg-inline--fa fa-times fa-w-11" aria-hidden="true" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 352 512" data-fa-i2svg="">
                        <path fill="currentColor"
                              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                    </svg>
                </div>

            </div>
        );
    }
}

export default BasketItem;